"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = void 0;
const react_1 = __importDefault(require("react"));
const CssBaseline_1 = __importDefault(require("@material-ui/core/CssBaseline"));
const styles_1 = require("@material-ui/core/styles");
const theme_hook_1 = require("./theme-hook");
function ThemeProvider({ children, ...options }) {
    const theme = theme_hook_1.useTheme(options);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.ThemeProvider, { theme: theme },
            react_1.default.createElement(CssBaseline_1.default, null),
            children)));
}
exports.ThemeProvider = ThemeProvider;
//# sourceMappingURL=theme-provider.js.map